import React, { useEffect, useState } from "react";

export default function BigSearchComponent({value, search}) {
  const [data, setData] = useState("")

    useEffect(()=>{setData(value)},[value])

  return (
    <div className="bg-white">
      <div className="content">
        <form className="push" onSubmit={()=> search(data)}>
          <div className="input-group input-group-lg">
            <input
              type="text"
              value={data}
              onChange={evt => setData(evt.target.value)}
              className="form-control form-control-alt"
              placeholder="Pesquisar..."
            />
            <div className="input-group-append">
              <span className="input-group-text border-0 bg-body">
                <i className="fa fa-fw fa-search"></i>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
